const config = {
  NODE_ENV: process.env.NODE_ENV,
  NAME_KEY: process.env.REACT_APP_NAME_KEY || "App",
  NAME_TITLE: process.env.REACT_APP_NAME_TITLE || "app",
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID || "",
};

export default config;
